var _style, _g, _g2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackspaceArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#010B6C;}\r\n\t.st2{display:none;fill:#FFDD67;stroke:#010B6C;stroke-miterlimit:10;}\r\n\t.st3{display:none;fill:none;stroke:#010B6C;stroke-miterlimit:10;}\r\n\t.st4{fill:#010B6C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,5.9C12.2,5.9,5.9,12.2,5.9,20S12.2,34.1,20,34.1S34.1,27.8,34.1,20S27.8,5.9,20,5.9z M27,21 c-0.1,0.1-0.1,0.2-0.2,0.4l-5.9,5.9c-0.6,0.6-1.5,0.6-2.1,0s-0.6-1.5,0-2.1l3.7-3.7H14c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h8.3 l-3.5-3.5c-0.6-0.6-0.6-1.6,0-2.1s1.5-0.6,2.1,0l5.9,5.9l0,0c0.4,0.3,0.7,0.7,0.7,1.3C27.5,20.3,27.3,20.7,27,21z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-28.6,5.9c-7.8,0-14.1,6.3-14.1,14.1c0,7.8,6.3,14.1,14.1,14.1s14.1-6.3,14.1-14.1S-20.8,5.9-28.6,5.9z  M-22.6,21.4H-31l3.7,3.7c0.6,0.6,0.6,1.5,0,2.1s-1.5,0.6-2.1,0l-5.9-5.9c-0.1-0.1-0.2-0.2-0.2-0.4c-0.3-0.3-0.5-0.6-0.5-1.1 c0-0.5,0.3-1,0.7-1.3l0,0l5.9-5.9c0.6-0.6,1.5-0.6,2.1,0s0.6,1.6,0,2.1l-3.5,3.5h8.3c0.8,0,1.5,0.7,1.5,1.5 C-21.1,20.8-21.8,21.4-22.6,21.4z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.3,11.9l2.5,5c0,0.1,0.1,0.1,0.2,0.2l5.5,0.8c0.2,0,0.3,0.3,0.2,0.5l-4,3.9c-0.1,0.1-0.1,0.2-0.1,0.3 l0.9,5.5c0,0.2-0.2,0.4-0.4,0.3l-4.9-2.6c-0.1,0-0.2,0-0.3,0l-4.9,2.6c-0.2,0.1-0.5-0.1-0.4-0.3l0.9-5.5c0-0.1,0-0.2-0.1-0.3l-4-3.9 c-0.2-0.2-0.1-0.5,0.2-0.5l5.5-0.8c0.1,0,0.2-0.1,0.2-0.2l2.5-5C19.9,11.7,20.1,11.7,20.3,11.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.1,11.9l2.5,5c0,0.1,0.1,0.1,0.2,0.2l5.5,0.8c0.2,0,0.3,0.3,0.2,0.5l-4,3.9c-0.1,0.1-0.1,0.2-0.1,0.3 l0.9,5.5c0,0.2-0.2,0.4-0.4,0.3l-5-2.6c-0.1,0-0.2,0-0.3,0l-5,2.6c-0.2,0.1-0.5-0.1-0.4-0.3l0.9-5.5c0-0.1,0-0.2-0.1-0.3l-4-3.9 c-0.2-0.2-0.1-0.5,0.2-0.5l5.5-0.8c0.1,0,0.2-0.1,0.2-0.2l2.5-5C40.7,11.7,41,11.7,41.1,11.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.8,18.4H26c0,0,1.5,0.1,1.5,1.5S26,21.4,26,21.4h-8.4l3.7,3.7c0,0,1,1.1,0,2.1c-1,1-2.1,0-2.1,0l-6.2-6.2 c0,0-1.1-1,0-2.1c1.1-1.1,6.2-6.2,6.2-6.2s1.1-1,2.1,0c1,1,0,2.1,0,2.1L17.8,18.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspaceArrow);
export default __webpack_public_path__ + "static/media/BackspaceArrow.6b91c9ec0e98ca2ee38f6bb31546d84f.svg";
export { ForwardRef as ReactComponent };